import DateInput from "@/components/Common/DateInput/DateInput.vue";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { uploadFile } from "@/helpers/fileHelper";

export default {
  name: "POIJobPostingEditDialog",
  components: {
    DateInput,
    InfoDialog
  },
  props: ["editedJobPosting", "editedItem", "dialog"],
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    logoDragging: false,
    isFormValid: false
  }),
  methods: {
    closeDialog() {
      this.$emit("close", null);
    },
    async saveAndClose() {
      const form = this.$refs.jobPostingForm;
      const isValid = await form.validate();
      if (isValid) {
        this.$emit("close", this.editedJobPosting);
      }
    },
    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.onload = ({ target }) => {
            if (target?.result) resolve(target.result);
            else reject("Unable to read File");
          };
          reader.readAsDataURL(file);
        } else reject("No file passed");
      });
    },
    async setLogoFile(e) {
      const file = e?.dataTransfer?.files?.[0] ?? e;
      if (file) {
        const res = await uploadFile(
          file,
          this.editedItem.id || this.editedItem._id,
          "pois",
          this.editedItem.principal
        );
        this.editedJobPosting.logo = {
          url: res.url,
          originalUrl: ""
        };
      }
      this.logoDragging = false;
    },
    async removeLogoFile() {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie das Logo löschen möchten?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        this.editedJobPosting.logo = "";
      }
    },
    featureChecked(checked, id) {
      if (!Array.isArray(this.editedJobPosting.features)) {
        this.$set(this.editedJobPosting, "features", []);
      }

      if (checked && !this.editedJobPosting.features.includes(id)) {
        this.editedJobPosting.features.push(id);
      } else if (!checked && this.editedJobPosting.features.includes(id)) {
        this.editedJobPosting.features.remove(id);
      }
      this.editedJobPosting.features = [
        ...new Set(this.editedJobPosting.features)
      ];
    },
    addLocation() {
      if (!Array.isArray(this.editedJobPosting.locations)) {
        this.$set(this.editedJobPosting, "locations", []);
      }
      this.editedJobPosting.locations.push({
        country: "",
        region: "",
        postal_code: "",
        city: "",
        street: "",
        formatted_address: ""
      });
    },
    removeLocation() {
      this.editedJobPosting.locations.pop();
    }
  },
  computed: {
    logoFileUrl() {
      return this.editedJobPosting.logo?.url;
    },
    jobPostingsFeatureGroups() {
      const groups = this.$store.state.featureGroups;
      return groups.filter(group => group.services?.includes("jobPostings"));
    }
  }
};
